import React from 'react'
import Modal from "react-bootstrap/Modal";
import { MdErrorOutline } from "react-icons/md";

const ErrorMassagePupUp = ({ show, onHide, Massage }) => {
    return (
        <>
            <Modal
                show={show}
                onHide={onHide}
                backdrop="static"
                keyboard={false}
                centered
                dialogClassName="custom-modal-width"
            >
                <Modal.Header closeButton>
                    <h5 className="text-danger d-flex align-items-center gap-2">
                        {/* <MdErrorOutline size={24} /> */}
                        Error Notification
                    </h5>
                </Modal.Header>

                <Modal.Body
                    style={{
                        color: "#333",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        textAlign: "center",
                        minHeight: "120px",
                        gap: "10px",
                    }}
                >
                    <MdErrorOutline size={50} color="#dc3545" />

                    <h6 className="mt-2">
                        {Massage}
                    </h6>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default ErrorMassagePupUp
